import FilterParameter from '~/utils/FilterParameter/FilterParameter';

export enum SortField {
	brandName = 'brandName',
	atc = 'atc',
	marketingAuthorizationHolder = 'marketingAuthorizationHolder',
	activeSubstance = 'activeSubstance',
	packageSize = 'packageSize',
	dosageForm = 'dosageForm',
	dosageStrength = 'dosageStrength',
	country = 'country',
	validFrom = 'validFrom',
	validTo = 'validTo',
	updatedAt = 'updatedAt',
	datasourceParsedAt = 'datasourceParsedAt',
}

export enum OrderDirection {
	asc = 'asc',
	desc = 'desc',
}

export default class Query<FilterValue extends string | string[] = string | string[]> {
	filterParameters: FilterParameter<FilterValue>[];

	sortField: SortField | null;

	order: OrderDirection | null;

	constructor(
		filterParameters: FilterParameter<FilterValue>[],
		sortField: SortField | null = null,
		order: OrderDirection | null = null
	) {
		this.filterParameters = filterParameters;
		this.sortField = sortField;
		this.order = order;
	}

	get key(): string {
		const filterKey = this.filterParameters.reduce(
			(result, parameter) => `${result},${parameter.name}=${parameter.value}`,
			''
		);
		return `${filterKey}-${String(this.sortField)}-${String(this.order)}`;
	}

	equals(other: any): boolean {
		return (
			other instanceof Query &&
			this.sortField === other.sortField &&
			this.order === other.order &&
			this.filterParametersEquals(other.filterParameters)
		);
	}

	filterParametersEquals(filterParameters: FilterParameter<string | string[]>[]): boolean {
		if (this.filterParameters === filterParameters) {
			return true;
		}
		if (this.filterParameters.length !== filterParameters.length) {
			return false;
		}
		return this.filterParameters.find((parameter, index) => !parameter.equals(filterParameters[index])) === undefined;
	}

	filterParametersUpdated(filterParameters: FilterParameter<string | string[]>[]): Query {
		return new Query(filterParameters, this.sortField, this.order);
	}
}
